import init from './thing'

const user =
{
    ...init ,
    me : 'Moi'
};

export default user ;
